import { CustomerModel, DealsModel, Handover, ValCallModel, WIPModel } from ".";

export type { ActivityModel } from "./ActivityModel";
export type { AgentModel } from "./AgentModel";
export type { AgentPipelineModel } from "./AgentPipelineModel";
export type { AllDepartmentsPipelineModel, DepartmentStatistics } from "./AllDepartmentsPipelineModel";
export type { AppointmentModel, CreateAppointmentModel } from "./AppointmentModel";
export type {
  AllocationModel,
  CallbackItem,
  CallbackSingleItem,
  ContactDetailsModel,
  CustomerCacheItem,
  CustomerCacheItemData,
  CustomerCacheItemElement,
  DealerAffiliateDataModel,
  TouchListModel,
} from "./CallbackModel";
export type { CustomerModel } from "./CustomerModel";
export type {
  DashboardAllocationModel,
  DashboardDocModel,
  DashboardPaidModel,
  DashboardPipelineModel,
  DashboardPredictionItem,
  DashboardPipelineStatistics,
  DashboardWIPModel,
  DashboardWIPWithTotals,
} from "./LeadershipPipelineModel";
export type { SalesHierarchyModel } from "./SalesHierarchyModel";
export type { DealsModel } from "./DealsModel";
export type { DepartmentPipelineModel } from "./DepartmentPipelineModel";
export type { DirectorAllocationModel } from "./DirectorAllocationModel";
export type { DirectorDocModel } from "./DirectorDocModel";
export type { DirectorPaidModel } from "./DirectorPaidModel";
export type { DirectorPipelineModel } from "./DirectorPipelineModel";
export type { DirectorWIPModel } from "./DirectorWIPModel";
export type { ApplicationHandoverModel, Handover } from "./HandoverModel";
export type { HandoverCreateRequest, HandoverToUpdateRequest } from "./HandoverRequestModels";
export type { MemberLastOnlineResponse } from "./MemberModel";
export type { PredictionModel } from "./PredictionModel";
export type { ValCallModel } from "./ValCallModel";
export type { WIPModel } from "./WIPModel";

export { PipelineActivityType } from "./ActivityModel";
export { AppointmentType } from "./AppointmentModel";
export { PredictionType } from "./PredictionModel";

export enum ValCallResult {
  Completed = "Completed",
  NotCompleted = "NotCompleted",
  NotRequired = "NotRequired",
}

export type ApplicationModel = Handover | ValCallModel | WIPModel | CustomerModel | DealsModel;
